import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Role } from '../models/role.model';

@Injectable({ providedIn: 'root' })
export class RoleService {
  private rolesUrl = '/roles';

  private roles: Role[];

  constructor(private http: HttpClient) {}

  getRoles(): Observable<Role[]> {
    if (this.roles) {
      return of(this.roles);
    }

    return this.http.get<any>(this.rolesUrl).pipe(
      map((response) => {
        const roles: Role[] = response.data;
        this.roles = roles;
        return roles;
      }),
      catchError(this.handleError),
    );
  }

  private handleError(error: any) {
    // FIXME
    console.error('An error occurred', error);
    return throwError(() => error.message || error);
  }
}
